import { FormattedEvent } from '@eventbrite/event-renderer';

/**
 * @name hasSameEvents
 * @description extracts event ids from supplied arrays of event objects,
 * flattents the arrays to strings and performs a strict comparison, returning
 * a boolean indicating whether the two match
 * @param {obj} prevEvents the previous event set, e.g. `prevProps.events`
 * @param {obj} events the current event set, e.g. `this.props.events`
 * @returns {boolean}
 */
export const hasSameEvents = (
    prevEvents: FormattedEvent[],
    events: FormattedEvent[],
) => {
    const prevEventsArr: any[] = [];
    const eventsArr: any[] = [];

    prevEvents.map((event) => {
        prevEventsArr.push(event.id);
    });

    events.map((event) => {
        eventsArr.push(event.id);
    });

    return prevEventsArr.toString() === eventsArr.toString();
};
